import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { ProtectedRoute, PublicRoute } from "./";
import { ROUTES } from "./routePaths";

// Pages
import LoginPage from "../pages/login/login";
import Auth from "../pages/auth/auth";
import DashboardPage from "../pages/dashboard/dashboard";
import MappingPage from "../pages/mappings/Mappings";
import DynamicTable from "../components/dashboard/DynamicTable";
import ImportDataPage from "../pages/import/ImportPage";
import InventoryPage from "../pages/inventory/InventoryPage";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path={ROUTES.LOGIN}
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />

      {/* Protected Routes */}
      <Route
        path={ROUTES.HOME}
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.MAPPINGS}
        element={
          <ProtectedRoute>
            <MappingPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.ANALYTICS_TABLES}
        element={
          <ProtectedRoute>
            <DynamicTable />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.IMPORT_PAGE}
        element={
          <ProtectedRoute>
            <ImportDataPage />
          </ProtectedRoute>
        }
      />

      <Route
        path={ROUTES.INVENTORY}
        element={
          <ProtectedRoute>
            <InventoryPage />
          </ProtectedRoute>
        }
       />



      <Route
        path="/auth/:method"
        element={<Auth />}
        />

      {/* Catch-all (404 fallback) */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;